// import React, { useEffect, useMemo, useState } from 'react';
// import { useNavigate, useParams } from 'react-router-dom';
// import Swal from 'sweetalert2';
// import axios from 'axios';
// import { Col, Form, Row, Table } from 'react-bootstrap';
// import Select from 'react-select';
// import { IoMdClose } from 'react-icons/io';
// import debounce from 'lodash/debounce';
// import CommonDcFields from '../CommonDcFields';
// import { BASE_URL } from '../../../services/Api';
// import { authHeader } from '../../../services/auth-header';
// import { Spinner } from 'react-bootstrap';

// function MDCCreate() {
//     const navigate = useNavigate();
//     const { id } = useParams();
//     const [isLoading, setIsLoading] = useState(false);
//     const [customermaterialcode, setCustomermaterialcode] = useState('');
//     const [deliveryterm, setDeliveryterm] = useState('');
//     const [deliverynotedate, setdeliverynotedate] = useState('');
//     const [sono, setsono] = useState('');
//     const [sodate, setsodate] = useState('');
//     const [buyerorderno, setbuyerorderno] = useState('');
//     const [buyerorderdate, setAmendmentdate] = useState('');
//     const [destination, setdestination] = useState('');
//     const [dispatchthrough, setdispatchthrough] = useState('');
//     const [otherreference, setotherreference] = useState('');
//     const [dispatchdocno, setdispatchdocno] = useState('');
//     const [kindattn, setkindattn] = useState('');
//     const [termsofdelivery, settermsofdelivery] = useState('');

//     // Common fields data state
//     const [commonFieldsData, setCommonFieldsData] = useState({
//         customer: null,
//         customerDetails: {
//             contactperson: '',
//             contactno: '',
//             email: '',
//             freight: '',
//             packingandforwarding: '',
//             paymentterm: ''
//         },
//         customerMultipleAddress: null,
//         branch: null,
//         warehouse: null,
//         shipTo: null,
//         billTo: null,
//     });

//     // Product and charges state
//     const [selectedProduct, setSelectedProduct] = useState(null);
//     const [productOptions, setProductOptions] = useState([]);
//     const [productSearch, setProductSearch] = useState(encodeURIComponent(" "));
//     const [rows, setRows] = useState([]);
//     const [additionalCharges, setAdditionalCharges] = useState([
//         {
//             id: Date.now(),
//             description: "",
//             chargepercent: 0,
//             amount: 0,
//             gstPercent: 0,
//             isPercentBased: true,
//         },
//     ]);

//     // Static options
//     const chargeOptions = [
//         { value: "Charges for Certification", label: "Charges for Certification" },
//         { value: "Clearing Forwarding Charges", label: "Clearing Forwarding Charges" },
//         { value: "Delivery Order Charges", label: "Delivery Order Charges" },
//         { value: "Export Preparation Charges", label: "Export Preparation Charges" },
//         { value: "Extra Machining Charges", label: "Extra Machining Charges" },
//         { value: "Handling Charges", label: "Handling Charges" },
//         { value: "IGC Charges", label: "IGC Charges" },
//         { value: "Import Preparation Charges", label: "Import Preparation Charges" },
//         { value: "Inspection Charges", label: "Inspection Charges" },
//         { value: "Insurance Charges", label: "Insurance Charges" },
//         { value: "Labour Charges", label: "Labour Charges" },
//         { value: "Late Delivery Charges", label: "Late Delivery Charges" },
//         { value: "Packing & Forwarding Charges", label: "Packing & Forwarding Charges" },
//         { value: "Pattern Charges", label: "Pattern Charges" },
//         { value: "Technical Service Charges", label: "Technical Service Charges" },
//         { value: "Testing & Inspection Charges", label: "Testing & Inspection Charges" },
//         { value: "Transportation Charges", label: "Transportation Charges" },
//     ];

//     const unitOptions = [
//         { value: "", label: "Select UOM" },
//         { value: "bot", label: "Bot" },
//         { value: "ctn", label: "Ctn" },
//         { value: "days", label: "Days" },
//         { value: "ft", label: "Ft" },
//         { value: "hrs", label: "Hrs" },
//         { value: "kg", label: "Kg" },
//         { value: "ltr", label: "Ltr" },
//         { value: "mtr", label: "Mtr" },
//         { value: "nos", label: "Nos" },
//         { value: "pil", label: "Pil" },
//         { value: "pkt", label: "Pkt" },
//         { value: "set", label: "Set" },
//         { value: "pcs", label: "Pcs" },
//     ];


//     const [deliverynoteno, setdeliverynoteno] = useState('');
//     const [enquiryValidationMsg, setEnquiryValidationMsg] = useState('');
//     const [isEnquiryValid, setIsEnquiryValid] = useState(false);
//     const [formSubmitted, setFormSubmitted] = useState(false);


//     // Handle common fields data change
//     const handleCommonFormData = (data) => {
//         setCommonFieldsData(data);
//     };

//     const checkdeliverynoteno = async (number) => {
//         if (!number) {
//             setEnquiryValidationMsg('');
//             setIsEnquiryValid(false);
//             return;
//         }


//         if (!/^[A-Za-z0-9-]+$/.test(number)) {
//             setEnquiryValidationMsg('❌ Only alphanumeric characters and hyphens are allowed');
//             setIsEnquiryValid(false);
//             return;
//         }

//         try {
//             const response = await axios.get(`${BASE_URL}deliveryChallan/check/${number}`, {
//                 headers: authHeader(),
//             });

//             if (response.data === true) {
//                 setEnquiryValidationMsg('❌ This delivery challan number already exists.');
//                 setIsEnquiryValid(false);
//             } else if (response.data === false) {
//                 setEnquiryValidationMsg('✅ This delivery challan number is available.');
//                 setIsEnquiryValid(true);
//             } else {
//                 setEnquiryValidationMsg('Unexpected response from server.');
//                 setIsEnquiryValid(false);
//             }
//         } catch (error) {
//             console.error("Error checking enquiry number:", error);
//             setEnquiryValidationMsg('❌ Error validating enquiry number.');
//             setIsEnquiryValid(false);
//         }
//     };


//     useEffect(() => {
//         const debouncedCheck = debounce(() => {
//             checkdeliverynoteno(deliverynoteno);
//         }, 400);

//         debouncedCheck();

//         return () => debouncedCheck.cancel();
//     }, [deliverynoteno]);

//     // Fetch product data
//     const getPumpProductData = async () => {
//         try {
//             const response = await axios.get(
//                 `${BASE_URL}product/page/ptype/0/10/desc/id/1/Finished,Raw Material, Semi Finished,Services/${productSearch}`,
//                 { headers: authHeader() }
//             );
//             const products = response.data.Index || response.data.data || [];
//             setProductOptions(
//                 products.map((product) => ({
//                     value: product.id,
//                     label: `${product.description} - ${product.moc} - ${product.size} - ${product.tagnumber} - ${product.serialnumber} - ${product.partno}`,
//                     description: product.description,
//                     uom: product.unitofmeasurement || unitOptions[0].value,
//                     igst: product.igst || 0,
//                     partno: product.partno,
//                     serialnumber: product.serialnumber,
//                     modelnumber: product.modelnumber,
//                     tagnumber: product.tagnumber,
//                     hsnsacno: product.hsnsacno,
//                     moc: product.moc || "",
//                     type: product.type || "",
//                     size: product.size || "",
//                     rating: product.rating || "",
//                     classes: product.classes || "",
//                     schedule: product.schedule || "",
//                     certification: product.certification || "",
//                 }))
//             );
//         } catch (error) {
//             Swal.fire("Error", "Failed to fetch product data", "error");
//         }
//     };

//     useEffect(() => {
//         getPumpProductData();
//     }, [productSearch]);

//     const handleProductSearchChange = debounce((inputValue) => {
//         setProductSearch(inputValue ? encodeURIComponent(inputValue) : encodeURIComponent(" "));
//     }, 500);

//     // Handle product selection
//     const handleProductChange = (selectedOption) => {
//         setSelectedProduct(selectedOption);
//         const selectedProductData = productOptions.find(
//             (product) => product.value === selectedOption.value
//         );

//         if (selectedProductData) {
//             const newRow = {
//                 description: selectedProductData.description,
//                 value: selectedProductData.value,
//                 label: selectedProductData.label,
//                 productremarks: "",
//                 quantity: "",
//                 uom: selectedProductData.uom || "",
//                 unitRateInr: selectedProductData.unitrateinr || 0,
//                 gstPercent: selectedProductData.igst || 0,
//                 amount: selectedProductData.unitrateinr || 0,
//                 totalinr: (selectedProductData.unitrateinr || 0) * (1 + (selectedProductData.igst || 0) / 100),
//                 hsnsacno: selectedProductData.hsnsacno,
//                 partno: selectedProductData.partno,
//                 serialnumber: selectedProductData.serialnumber,
//                 moc: selectedProductData.moc || "",
//                 type: selectedProductData.type || "",
//                 size: selectedProductData.size || "",
//                 rating: selectedProductData.rating || "",
//                 classes: selectedProductData.classes || "",
//                 schedule: selectedProductData.schedule || "",
//                 certification: selectedProductData.certification || "",
//             };
//             setRows([...rows, newRow]);
//         }
//     };


//     // Create empty charge row
//     const createEmptyCharge = () => ({
//         id: Date.now(),
//         description: "",
//         chargepercent: 0,
//         amount: 0,
//         gstPercent: 0,
//         isPercentBased: true,
//     });

//     // Handle charge changes
//     const handleChargeChange = (index, field, value, isBlur = false) => {
//         setAdditionalCharges(prev => {
//             const newCharges = [...prev];
//             const charge = { ...newCharges[index] };
//             const netTotal = rows.reduce((sum, row) => sum + (row.totalinr || 0), 0);

//             if (field === "chargepercent") {
//                 const percentage = Math.min(value, 100);
//                 charge.chargepercent = percentage;

//                 // Only calculate amount on blur or when percentage reaches 100
//                 if (isBlur || percentage === 100) {
//                     charge.amount = (percentage * netTotal) / 100;
//                 } else {
//                     // Temporarily keep amount as 0 while typing
//                     charge.amount = 0;
//                 }
//             }
//             else if (field === "amount") {
//                 charge.amount = value;
//                 charge.chargepercent = 0;
//             }
//             else {
//                 charge[field] = value;
//             }

//             newCharges[index] = charge;
//             return newCharges;
//         });
//     };

//     // Add new charge row
//     const addNewChargeRow = () => {
//         setAdditionalCharges((prev) => [...prev, createEmptyCharge()]);
//     };

//     // Remove charge row
//     const removeChargeRow = (index) => {
//         if (additionalCharges.length > 0) {
//             setAdditionalCharges((prev) => prev.filter((_, i) => i !== index));
//         }
//     };

//     // Remove product row
//     const removeRow = (index) => {
//         const updatedRows = [...rows];
//         updatedRows.splice(index, 1);
//         setRows(updatedRows);
//     };

//  const handleRowChange = (index, key, value) => {
//     const updatedRows = [...rows];
//     updatedRows[index][key] = value;

//     if (["quantity", "unitRateInr", "gstPercent"].includes(key)) {
//       const quantity = parseFloat(updatedRows[index].quantity) || 0;
//       const unitRateInr = parseFloat(updatedRows[index].unitRateInr) || 0;
//       const gstPercent = parseFloat(updatedRows[index].gstPercent) || 0;

//       // Calculate base amount (quantity * unit price)
//       const amount = quantity * unitRateInr;

//       // Calculate GST amount
//       const gstAmount = (amount * gstPercent) / 100;

//       // Calculate total including GST
//       const totalinr = amount + gstAmount;

//       updatedRows[index].amount = amount;
//       updatedRows[index].totalinr = totalinr;
//     }

//     setRows(updatedRows);
//   };

//     const productsTotal = useMemo(() => {
//     return rows.reduce((total, row) => {
//       const rowTotal = (row.quantity || 0) * (row.unitRateInr || 0) * (1 + (row.gstPercent || 0) / 100);
//       return total + rowTotal;
//     }, 0);
//   }, [rows]);

//     useEffect(() => {
//         // Recalculate charge amounts based on percentages when productsTotal changes
//         setAdditionalCharges(prevCharges => {
//             return prevCharges.map(charge => {
//                 if (charge.chargepercent > 0) {
//                     return {
//                         ...charge,
//                         amount: (charge.chargepercent * productsTotal) / 100
//                     };
//                 }
//                 return charge;
//             });
//         });
//     }, [productsTotal]); 

//     // Calculate charges total (sum of all charges including GST)
//     const additionalChargesTotal = useMemo(() => {
//         return additionalCharges.reduce((total, charge) => {
//             const chargeTotal = (charge.amount || 0) * (1 + (charge.gstPercent || 0) / 100);
//             return total + chargeTotal;
//         }, 0);
//     }, [additionalCharges]);

//     // Calculate gross total and round to nearest integer
//     const grossTotal = productsTotal + additionalChargesTotal;
//     const roundedGrossTotal = Math.round(grossTotal);

//     // Grand Total equals the rounded gross total
//     const grandTotal = roundedGrossTotal;

//     // Form validation
//     const validateForm = () => {
//         if (!isEnquiryValid) {  // Changed from issoValid to isEnquiryValid
//             Swal.fire("Error", "Please enter a valid delivery challan number", "error");
//             return false;
//         }
//         if (!commonFieldsData.customer) {
//             Swal.fire("Error", "Please select a customer", "error");
//             return false;
//         }
//         if (!commonFieldsData.customerMultipleAddress) {
//             Swal.fire("Error", "Please select customer address", "error");
//             return false;
//         }
//         if (rows.length === 0) {
//             Swal.fire("Error", "Please add at least one product", "error");
//             return false;
//         }
//         return true;
//     };

//     // Handle form submission
//     const handleSubmit = async () => {
//         if (!validateForm()) return;

//         setIsLoading(true);

//         // Prepare sales order items
//         const deliveryChallanItems = rows.map((row) => ({
//             product: { id: row.value },
//             quantity: row.quantity,
//             uom: row.uom,
//             unitrateinr: row.unitRateInr,
//             gst: row.gstPercent,
//             amount: row.amount,
//             totalinr: row.totalinr,
//             productremarks: row.productremarks,
//             partno: row.partno || "",
//             hsnsacno: row.hsnsacno || "",
//             serialnumber: row.serialnumber || "",
//             moc: row.moc || "",
//             type: row.type || "",
//             size: row.size || "",
//             rating: row.rating || "",
//             classes: row.classes || "",
//             schedule: row.schedule || "",
//             certification: row.certification || "",
//         }));

//         // Prepare additional charges
//         const additionalChargesData = additionalCharges
//             .filter((charge) => charge.description && (charge.amount > 0 || charge.chargepercent > 0))
//             .map((charge) => ({
//                 chargetype: charge.description,
//                 chargepercent: charge.chargepercent,
//                 chargeamount: charge.amount,
//                 chargegst: charge.gstPercent,
//                 chargetotal: charge.amount + (charge.amount * charge.gstPercent) / 100,
//                 isPercentBased: charge.isPercentBased,
//             }));

//         // Calculate totals
//         const additionalChargesTotal = additionalChargesData.reduce(
//             (sum, charge) => sum + charge.chargetotal,
//             0
//         );

//         const productsTotal = deliveryChallanItems.reduce(
//             (sum, item) => sum + item.totalinr,
//             0
//         );

//         const grossTotal = productsTotal + additionalChargesTotal;

//         // Prepare payload
//         const payload = {
//             customer: commonFieldsData.customer ? { id: commonFieldsData.customer.value } : null,
//             contactperson: commonFieldsData.customerDetails?.contactperson,
//             contactno: commonFieldsData.customerDetails?.contactno,
//             email: commonFieldsData.customerDetails?.email,
//             customeraddress: commonFieldsData.customerMultipleAddress
//                 ? { id: commonFieldsData.customerMultipleAddress.value }
//                 : null,
//             freight: commonFieldsData.customerDetails.freight,
//             packingandforwarding: commonFieldsData.customerDetails.packingandforwarding,
//             paymentterm: commonFieldsData.customerDetails.paymentterm,
//             shipto: commonFieldsData.shipTo ? { id: commonFieldsData.shipTo.value } : null,
//             billto: commonFieldsData.billTo ? { id: commonFieldsData.billTo.value } : null,
//             branch: commonFieldsData.branch ? { id: commonFieldsData.branch.value } : null,
//             warehouse: commonFieldsData.warehouse ? { id: commonFieldsData.warehouse.value } : null,
//             deliveryChallanItems: deliveryChallanItems,
//             additionalCharges: additionalChargesData.length > 0 ? additionalChargesData : null,
//             nettotalproduct: productsTotal,
//             additionalchargestotal: additionalChargesTotal,
//             grosstotal: grossTotal,
//             grandtotalproduct: grossTotal,
//             deliverychallantype: "Manufacturing",
//             deliverychallancategory: "Domestic",
//             deliverynoteno,
//             deliverynotedate,
//             sodate,
//             sono,
//             customermaterialcode,
//             deliveryterm,
//             dispatchdocno,
//             kindattn,
//             termsofdelivery,
//             buyerorderno,
//             buyerorderdate,
//             destination,
//             dispatchthrough,
//             otherreference,
//         };

//         try {
//             const response = await axios.post(`${BASE_URL}deliveryChallan/save`, payload, {
//                 headers: authHeader(),
//             });
//             Swal.fire("Success", "delivery challan created successfully", "success");
//             navigate("/dcindex/1");
//         } catch (error) {
//             console.error("Submission error:", error);
//             Swal.fire(
//                 "Error",
//                 error.response?.data?.message ||
//                 error.response?.data ||
//                 "Failed to create delivery challan",
//                 "error"
//             );
//         } finally {
//             setIsLoading(false);
//         }
//     };



//     return (
//         <div className="container">
//             <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>

//                 <Row className="mb-3">

//                     {/* DELIVERY NOTE DETAILS */}

//                     <Col md={6}>
//                         <Form.Group>
//                             <Form.Label>Delivery Note Number: *</Form.Label>
//                             <Form.Control
//                                 type="text"
//                                 value={deliverynoteno}
//                                 onChange={e => {
//                                     setdeliverynoteno(e.target.value);
//                                     setFormSubmitted(false);
//                                 }}
//                                 isInvalid={
//                                     (formSubmitted && !isEnquiryValid) ||
//                                     enquiryValidationMsg.includes('exists') ||
//                                     enquiryValidationMsg.includes('Error') ||
//                                     enquiryValidationMsg.includes('allowed')
//                                 }
//                                 required
//                             />
//                             {enquiryValidationMsg && (
//                                 <Form.Control.Feedback type={
//                                     enquiryValidationMsg.includes('exists') ||
//                                         enquiryValidationMsg.includes('Error') ||
//                                         enquiryValidationMsg.includes('allowed') ?
//                                         "invalid" : "valid"
//                                 }>
//                                     {enquiryValidationMsg}
//                                 </Form.Control.Feedback>
//                             )}
//                             {formSubmitted && !isEnquiryValid && !enquiryValidationMsg && (
//                                 <Form.Control.Feedback type="invalid">
//                                     Please enter a valid enquiry number
//                                 </Form.Control.Feedback>
//                             )}
//                         </Form.Group>   
//                     </Col>
//                     <Col md={6}>
//                         <Form.Group>
//                             <Form.Label>Delivery Note Date</Form.Label>
//                             <Form.Control
//                                 type="date"
//                                 value={deliverynotedate}
//                                 onChange={e => setdeliverynotedate(e.target.value)}
//                             />
//                         </Form.Group>
//                     </Col>

//                     {/* SALES ORDER DETAILS */}
//                     <Col md={6}>
//                         <Form.Group controlId="sono">
//                             <Form.Label>Sales Order No.</Form.Label>
//                             <Form.Control
//                                 type="text"
//                                 value={sono}
//                                 onChange={(e) => setsono(e.target.value)}
//                             />
//                         </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                         <Form.Group controlId="sodate">
//                             <Form.Label>Sales Order Date</Form.Label>
//                             <Form.Control
//                                 type="date"
//                                 value={sodate}
//                                 onChange={(e) => setsodate(e.target.value)}
//                             />
//                         </Form.Group>
//                     </Col>

//                     {/* BUYER ORDER DETAILS */}
//                     <Col md={6}>
//                         <Form.Group controlId="buyerorderno">
//                             <Form.Label>Buyer Order No.</Form.Label>
//                             <Form.Control
//                                 type="text"
//                                 value={buyerorderno}
//                                 onChange={(e) => setbuyerorderno(e.target.value)}
//                             />
//                         </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                         <Form.Group controlId="buyerorderdate">
//                             <Form.Label>Buyer Order Date</Form.Label>
//                             <Form.Control
//                                 type="date"
//                                 value={buyerorderdate}
//                                 onChange={(e) => setAmendmentdate(e.target.value)}
//                             />
//                         </Form.Group>
//                     </Col>

//                     {/* DISPATCH INFO */}
//                     <Col md={6}>
//                         <Form.Group controlId="dispatchthrough">
//                             <Form.Label>Dispatch Through</Form.Label>
//                             <Form.Control
//                                 type="text"
//                                 value={dispatchthrough}
//                                 onChange={(e) => setdispatchthrough(e.target.value)}
//                             />
//                         </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                         <Form.Group controlId="destination">
//                             <Form.Label>Destination</Form.Label>
//                             <Form.Control
//                                 type="text"
//                                 value={destination}
//                                 onChange={(e) => setdestination(e.target.value)}

//                             />
//                         </Form.Group>
//                     </Col>
//                 </Row>

//                 <Row>
//                     {/* Common Fields */}
//                     <CommonDcFields
//                         onDataChange={handleCommonFormData}
//                     />
//                 </Row>

//                 <Row>
//                     {/* ADDITIONAL INFO */}
//                     <Col md={6}>
//                         <Form.Group controlId="dispatchdocno">
//                             <Form.Label>Dispatch Doc No.</Form.Label>
//                             <Form.Control
//                                 type="text"
//                                 value={dispatchdocno}
//                                 onChange={(e) => setdispatchdocno(e.target.value)}
//                             />
//                         </Form.Group>
//                     </Col>
//                     <Col md={6}>
//                         <Form.Group controlId="kindattn">
//                             <Form.Label>Kind Attention</Form.Label>
//                             <Form.Control
//                                 type="text"
//                                 value={kindattn}
//                                 onChange={(e) => setkindattn(e.target.value)}
//                             />
//                         </Form.Group>
//                     </Col>

//                     <Col md={6}>
//                         <Form.Group controlId="termsofdelivery">
//                             <Form.Label>Delivery Term</Form.Label>
//                             <Form.Control
//                                 type="text"
//                                 value={termsofdelivery}
//                                 onChange={(e) => settermsofdelivery(e.target.value)}
//                             />
//                         </Form.Group>
//                     </Col>

//                     <Col md={12}>
//                         <Form.Group controlId="otherreference">
//                             <Form.Label>Other Reference</Form.Label>
//                             <Form.Control
//                                 as="textarea"
//                                 rows={2}
//                                 value={otherreference}
//                                 onChange={(e) => setotherreference(e.target.value)}
//                             />
//                         </Form.Group>
//                     </Col>

//                 </Row>

//                 {/* Products Section */}
//                 <div className="mt-4">
//                     <h5>Products</h5>
//                     <Row>
//                         <Col md="12">
//                             <Form.Group>
//                                 <Form.Label>Select Product</Form.Label>
//                                 <Select
//                                     value={selectedProduct}
//                                     onChange={handleProductChange}
//                                     options={productOptions}
//                                     placeholder="Search and select product"
//                                     onInputChange={handleProductSearchChange}
//                                     isClearable
//                                     menuPortalTarget={document.body}
//                                     styles={{
//                                         menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//                                     }}
//                                 />
//                             </Form.Group>
//                         </Col>
//                     </Row>

//                     <div className="table-responsive mt-3">
//                         <Table striped bordered hover>
//                             <thead>
//                                 <tr>
//                                     <th>Product</th>
//                                     <th>Part No.</th>
//                                     <th>HSN Code</th>
//                                     <th>Serial No.</th>
//                                     <th>MOC</th>
//                                     <th>Type</th>
//                                     <th>Size</th>
//                                     <th>Rating</th>
//                                     <th>class</th>
//                                     <th>Schedule</th>
//                                     <th>Certification</th>
//                                     <th>Quantity</th>
//                                     <th>unit of measurement</th>
//                                     <th>Unit Price (₹)</th>
//                                     <th>Amount (₹)</th>
//                                     <th>GST (%)</th>
//                                     <th>Total Amount (Incl. GST)</th>
//                                     <th>Action</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {rows.map((row, index) => (
//                                     <tr key={index}>
//                                         <td>
//                                             {row.description}
//                                             <Form.Control
//                                                 as="textarea"
//                                                 rows={2}
//                                                 value={row.productremarks}
//                                                 onChange={(e) =>
//                                                     handleRowChange(index, "productremarks", e.target.value)
//                                                 }
//                                                 placeholder="Remarks"
//                                                 className="mt-2"
//                                             />
//                                         </td>
//                                         <td>{row.partno}</td>
//                                         <td>{row.hsnsacno}</td>
//                                         <td>{row.serialnumber}</td>

//                                         <td>
//                                             <Form.Control
//                                                 className="remark"
//                                                 type="text"
//                                                 value={row.moc}
//                                                 onChange={(e) =>
//                                                     handleRowChange(index, "moc", e.target.value)
//                                                 }
//                                                 placeholder=" Enter item moc"
//                                             />
//                                         </td>
//                                         <td>
//                                             <Form.Control
//                                                 className="remark"
//                                                 type="text"
//                                                 value={row.type}
//                                                 onChange={(e) =>
//                                                     handleRowChange(index, "type", e.target.value)
//                                                 }
//                                                 placeholder=" Enter item type"
//                                             />
//                                         </td>
//                                         <td>
//                                             <Form.Control
//                                                 className="remark"
//                                                 type="text"
//                                                 value={row.size}
//                                                 onChange={(e) =>
//                                                     handleRowChange(index, "size", e.target.value)
//                                                 }
//                                                 placeholder=" Enter item size"
//                                             />
//                                         </td>
//                                         <td>
//                                             <Form.Control
//                                                 className="remark"
//                                                 type="text"
//                                                 value={row.rating}
//                                                 onChange={(e) =>
//                                                     handleRowChange(index, "rating", e.target.value)
//                                                 }
//                                                 placeholder=" Enter item rating"
//                                             />
//                                         </td>
//                                         <td>
//                                             <Form.Control
//                                                 className="remark"
//                                                 type="text"
//                                                 value={row.classes}
//                                                 onChange={(e) =>
//                                                     handleRowChange(index, "classes", e.target.value)
//                                                 }
//                                                 placeholder=" Enter item class"
//                                             />
//                                         </td>
//                                         <td>
//                                             <Form.Control
//                                                 className="remark"
//                                                 type="text"
//                                                 value={row.schedule}
//                                                 onChange={(e) =>
//                                                     handleRowChange(index, "schedule", e.target.value)
//                                                 }
//                                                 placeholder=" Enter item schedule"
//                                             />
//                                         </td>
//                                         <td>
//                                             <Form.Control
//                                                 className="remark"
//                                                 type="text"
//                                                 value={row.certification}
//                                                 onChange={(e) =>
//                                                     handleRowChange(index, "certification", e.target.value)
//                                                 }
//                                                 placeholder=" Enter item certification"
//                                             />
//                                         </td>
//                                         <td>
//                                             <Form.Control
//                                                 type="number"
//                                                 value={row.quantity}
//                                                 onChange={(e) =>
//                                                     handleRowChange(
//                                                         index,
//                                                         "quantity",
//                                                         parseFloat(e.target.value)
//                                                     )
//                                                 }
//                                             />
//                                         </td>
//                                         <td>
//                                             <Select
//                                                 value={unitOptions.find((opt) => opt.value === row.uom)}
//                                                 options={unitOptions}
//                                                 onChange={(selectedOption) =>
//                                                     handleRowChange(index, "uom", selectedOption.value)
//                                                 }
//                                                 menuPortalTarget={document.body}
//                                                 styles={{
//                                                     menuPortal: (base) => ({ ...base, zIndex: 9999 }),
//                                                 }}
//                                             />
//                                         </td>
//                                         <td>
//                                             <Form.Control
//                                                 type="number"

//                                                 step="0.01"
//                                                 value={row.unitRateInr}
//                                                 onChange={(e) =>
//                                                     handleRowChange(
//                                                         index,
//                                                         "unitRateInr",
//                                                         parseFloat(e.target.value)
//                                                     )
//                                                 }
//                                             />
//                                         </td>
//                                         <td className="text-end">₹{row.amount?.toFixed(2)}</td>
//                                         <td>
//                                             <Form.Control
//                                                 type="number"

//                                                 value={row.gstPercent}
//                                                 onChange={(e) =>
//                                                     handleRowChange(
//                                                         index,
//                                                         "gstPercent",
//                                                         parseFloat(e.target.value)
//                                                     )
//                                                 }
//                                             />
//                                         </td>
//                                         <td className="text-end">₹{row.totalinr?.toFixed(2)}</td>
//                                         <td className="text-center">
//                                             <button
//                                                 className="button-70 btn-danger"
//                                                 onClick={() => removeRow(index)}
//                                             >
//                                                 <IoMdClose />
//                                             </button>
//                                         </td>
//                                     </tr>
//                                 ))}
//                             </tbody>
//                         </Table>
//                     </div>
//                 </div>

//                 {/* Charges Section */}
//                 <div className="card mt-4">
//                     <div className="card-header bg-light">
//                         <strong>Summary & Charges</strong>
//                     </div>
//                     <div className="card-body">
//                         {/* Products Total */}
//                         <div className="d-flex justify-content-between align-items-center mb-3">
//                             <div className="fw-bold">Products Total:</div>
//                             <div className="fw-bold fs-6">₹{productsTotal.toFixed(2)}</div>
//                         </div>

//                         {/* Charges Header */}
//                         <div className="row g-2 mb-2 fw-bold border-bottom pb-2">
//                             <div className="col-md-4">Charge Type</div>
//                             <div className="col-md-2">Charge %</div>
//                             <div className="col-md-2">Amount (₹)</div>
//                             <div className="col-md-2">GST %</div>
//                             <div className="col-md-2 text-end">Total (₹)</div>
//                         </div>

//                         {/* Charges List */}
//                         {additionalCharges.map((charge, index) => {
//                             const gstAmount = (charge.amount * charge.gstPercent) / 100;
//                             const totalAmount = charge.amount + gstAmount;

//                             return (
//                                 <div key={charge.id} className="row g-2 mb-3 align-items-center">
//                                     {/* Charge Type Select */}
//                                     <div className="col-md-4">
//                                         <Select
//                                             value={chargeOptions.find(opt => opt.value === charge.description)}
//                                             onChange={(val) => handleChargeChange(index, "description", val.value)}
//                                             options={chargeOptions}
//                                             placeholder="Select charge"
//                                         />
//                                     </div>
//                                     {/* Charge % Field */}
//                                     <div className="col-md-2">
//                                         <Form.Control
//                                             type="number"

//                                             max="100"
//                                             value={charge.chargepercent || ""}
//                                             onChange={(e) => {
//                                                 let val = parseFloat(e.target.value) || 0;
//                                                 if (val > 100) {
//                                                     val = 100;
//                                                 }
//                                                 // Only update percentage while typing, don't calculate amount yet
//                                                 handleChargeChange(index, "chargepercent", val, false);
//                                             }}
//                                             onBlur={(e) => {
//                                                 // When field loses focus, calculate the final amount
//                                                 let val = parseFloat(e.target.value) || 0;
//                                                 if (val > 100) {
//                                                     Swal.fire("Warning", "Charge percentage cannot exceed 100%", "warning");
//                                                     val = 100;
//                                                 }
//                                                 handleChargeChange(index, "chargepercent", val, true);
//                                             }}
//                                             disabled={charge.amount > 0} // Only disable if amount has value
//                                         />
//                                     </div>
//                                     {/* Amount (₹) Field */}
//                                     <div className="col-md-2">
//                                         <Form.Control
//                                             type="number"

//                                             step="0.01"
//                                             value={charge.amount || ""}
//                                             onChange={(e) => {
//                                                 const val = parseFloat(e.target.value) || 0;
//                                                 handleChargeChange(index, "amount", val);
//                                             }}
//                                             disabled={charge.chargepercent > 0} // Only disable if percentage has value
//                                         />
//                                     </div>
//                                     {/* GST % Field */}
//                                     <div className="col-md-2">
//                                         <Form.Control
//                                             type="number"

//                                             value={charge.gstPercent}
//                                             onChange={(e) =>
//                                                 handleChargeChange(index, "gstPercent", parseFloat(e.target.value) || 0)
//                                             }
//                                         />
//                                     </div>

//                                     {/* Total Amount Display */}
//                                     <div className="col-md-2 text-end">
//                                         ₹{totalAmount.toFixed(2)}
//                                     </div>

//                                     {/* Remove Button */}
//                                     <div className="col-md-2 text-center">
//                                         <button
//                                             className="button-70 btn-danger"
//                                             onClick={() => removeChargeRow(index)}
//                                             disabled={additionalCharges.length <= 0}
//                                         >
//                                             <IoMdClose />
//                                         </button>
//                                     </div>
//                                 </div>
//                             );
//                         })}

//                         {/* Additional Charges Total */}
//                         <div className="d-flex justify-content-between align-items-center mb-3 border-top pt-2">
//                             <div className="fw-bold">Additional Charges Total:</div>
//                             <div className="fw-bold fs-6">
//                                 ₹{additionalChargesTotal.toFixed(2)}
//                             </div>
//                         </div>

//                         {/* Gross Total */}
//                         <div className="d-flex justify-content-between align-items-center mb-3 border-top pt-2">
//                             <div className="fw-bold">Gross Total:</div>
//                             <div className="fw-bold fs-6">₹{grossTotal.toFixed(2)}</div>
//                         </div>

//                         {/* Add Charge Button */}
//                         <div className="text-end mt-2">
//                             <button
//                                 type="button"
//                                 className="button-70 btn-success"
//                                 onClick={addNewChargeRow}
//                             >
//                                 + Add New Charge
//                             </button>
//                         </div>

//                         {/* Rounded Grand Total */}
//                         <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
//                             <div className="fw-bold fs-5">Grand Total (Rounded):</div>
//                             <div className="fw-bold fs-5 text-primary">
//                                 ₹{grandTotal.toFixed(2)}
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="d-flex justify-content-end mt-4">
//                     <button
//                         type="submit"
//                         className="btn btn-primary me-2"
//                         disabled={isLoading}
//                     >
//                         {isLoading ? (
//                             <>
//                                 <Spinner as="span" animation="border" size="sm" />
//                                 <span className="ms-2">Submitting...</span>
//                             </>
//                         ) : (
//                             "Submit"
//                         )}
//                     </button>
//                     <button
//                         type="button"
//                         className="btn btn-secondary"
//                         onClick={() => navigate(-1)}
//                     >
//                         Cancel
//                     </button>
//                 </div>
//             </Form>
//         </div>
//     );
// }

// export default MDCCreate;



import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import axios from 'axios';
import { Col, Form, Row, Spinner } from 'react-bootstrap';
import Select from 'react-select';
import debounce from 'lodash/debounce';

// Common Components Import
import ProductTableSales from '../../../Common/SalesMProduct';
import ChargesSection from "../../../Common/ChargesSection";
import { CHARGE_OPTIONS, UNIT_OPTIONS } from "../../../Common/constants";
import CommonDcFields from '../CommonDcFields';

import { BASE_URL } from '../../../services/Api';
import { authHeader } from '../../../services/auth-header';

function MDCCreate() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(false);
    const [customermaterialcode, setCustomermaterialcode] = useState('');
    const [deliveryterm, setDeliveryterm] = useState('');
    const [deliverynotedate, setdeliverynotedate] = useState('');
    const [sono, setsono] = useState('');
    const [sodate, setsodate] = useState('');
    const [buyerorderno, setbuyerorderno] = useState('');
    const [buyerorderdate, setAmendmentdate] = useState('');
    const [destination, setdestination] = useState('');
    const [dispatchthrough, setdispatchthrough] = useState('');
    const [otherreference, setotherreference] = useState('');
    const [dispatchdocno, setdispatchdocno] = useState('');
    const [kindattn, setkindattn] = useState('');
    const [termsofdelivery, settermsofdelivery] = useState('');
    const [deliverynoteno, setdeliverynoteno] = useState('');
    const [enquiryValidationMsg, setEnquiryValidationMsg] = useState('');
    const [isEnquiryValid, setIsEnquiryValid] = useState(false);
    const [formSubmitted, setFormSubmitted] = useState(false);

    // Common fields data state
    const [commonFieldsData, setCommonFieldsData] = useState({
        customer: null,
        customerDetails: {
            contactperson: '',
            contactno: '',
            email: '',
            freight: '',
            packingandforwarding: '',
            paymentterm: ''
        },
        customerMultipleAddress: null,
        branch: null,
        warehouse: null,
        shipTo: null,
        billTo: null,
    });

    // Product and charges state
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [productOptions, setProductOptions] = useState([]);
    const [productSearch, setProductSearch] = useState(encodeURIComponent(" "));
    const [rows, setRows] = useState([]);
    const [additionalCharges, setAdditionalCharges] = useState([
        {
            id: Date.now(),
            description: "",
            chargepercent: 0,
            amount: 0,
            gstPercent: 0,
            isPercentBased: true,
        },
    ]);

    // Handle common fields data change
    const handleCommonFormData = (data) => {
        setCommonFieldsData(data);
    };

    // Validate delivery challan number
    const checkdeliverynoteno = async (number) => {
        if (!number) {
            setEnquiryValidationMsg('');
            setIsEnquiryValid(false);
            return;
        }

        if (!/^[A-Za-z0-9-]+$/.test(number)) {
            setEnquiryValidationMsg('❌ Only alphanumeric characters and hyphens are allowed');
            setIsEnquiryValid(false);
            return;
        }

        try {
            const response = await axios.get(`${BASE_URL}deliveryChallan/check/${number}`, {
                headers: authHeader(),
            });

            if (response.data === true) {
                setEnquiryValidationMsg('❌ This delivery challan number already exists.');
                setIsEnquiryValid(false);
            } else if (response.data === false) {
                setEnquiryValidationMsg('✅ This delivery challan number is available.');
                setIsEnquiryValid(true);
            } else {
                setEnquiryValidationMsg('Unexpected response from server.');
                setIsEnquiryValid(false);
            }
        } catch (error) {
            console.error("Error checking delivery challan number:", error);
            setEnquiryValidationMsg('❌ Error validating delivery challan number.');
            setIsEnquiryValid(false);
        }
    };

    useEffect(() => {
        const debouncedCheck = debounce(() => {
            checkdeliverynoteno(deliverynoteno);
        }, 400);

        debouncedCheck();

        return () => debouncedCheck.cancel();
    }, [deliverynoteno]);

    // Fetch product data
    const getPumpProductData = async () => {
        try {
            const response = await axios.get(
                `${BASE_URL}product/page/ptype/0/10/desc/id/1/Finished,Raw Material, Semi Finished,Services/${productSearch}`,
                { headers: authHeader() }
            );
            const products = response.data.Index || response.data.data || [];
            setProductOptions(
                products.map((product) => ({
                    value: product.id,
                    label: `${product.description} - ${product.moc} - ${product.size} - ${product.tagnumber} - ${product.serialnumber} - ${product.partno}`,
                    description: product.description,
                    uom: product.unitofmeasurement || UNIT_OPTIONS[0].value,
                    igst: product.igst || 0,
                    partno: product.partno,
                    serialnumber: product.serialnumber,
                    modelnumber: product.modelnumber,
                    tagnumber: product.tagnumber,
                    hsnsacno: product.hsnsacno,
                    moc: product.moc || "",
                    type: product.type || "",
                    size: product.size || "",
                    rating: product.rating || "",
                    classes: product.classes || "",
                    schedule: product.schedule || "",
                    certification: product.certification || "",
                }))
            );
        } catch (error) {
            Swal.fire("Error", "Failed to fetch product data", "error");
        }
    };

    useEffect(() => {
        getPumpProductData();
    }, [productSearch]);

    const handleProductSearchChange = debounce((inputValue) => {
        setProductSearch(inputValue ? encodeURIComponent(inputValue) : encodeURIComponent(" "));
    }, 500);

    // Handle product selection
    const handleProductChange = (selectedOption) => {
        setSelectedProduct(selectedOption);
        const selectedProductData = productOptions.find(
            (product) => product.value === selectedOption.value
        );

        if (selectedProductData) {
            const newRow = {
                description: selectedProductData.description,
                value: selectedProductData.value,
                label: selectedProductData.label,
                productremarks: "",
                quantity: "",
                uom: selectedProductData.uom || "",
                unitRateInr: parseFloat((selectedProductData.unitrateinr || 0).toFixed(2)),
                gstPercent: parseFloat((selectedProductData.igst || 0).toFixed(2)),
                amount: parseFloat((selectedProductData.unitrateinr || 0).toFixed(2)),
                totalinr: parseFloat(((selectedProductData.unitrateinr || 0) * (1 + (selectedProductData.igst || 0) / 100)).toFixed(2)),
                hsnsacno: selectedProductData.hsnsacno,
                partno: selectedProductData.partno,
                serialnumber: selectedProductData.serialnumber,
                moc: selectedProductData.moc || "",
                type: selectedProductData.type || "",
                size: selectedProductData.size || "",
                rating: selectedProductData.rating || "",
                classes: selectedProductData.classes || "",
                schedule: selectedProductData.schedule || "",
                certification: selectedProductData.certification || "",
            };
            setRows([...rows, newRow]);
        }
    };

    // Create empty charge row
    const createEmptyCharge = () => ({
        id: Date.now(),
        description: "",
        chargepercent: 0,
        amount: 0,
        gstPercent: 0,
        isPercentBased: true,
    });

    // Handle charge changes with 2 decimal places
    const handleChargeChange = (index, field, value, isBlur = false) => {
        setAdditionalCharges(prev => {
            const newCharges = [...prev];
            const charge = { ...newCharges[index] };
            const netTotal = rows.reduce((sum, row) => sum + (row.totalinr || 0), 0);

            if (field === "chargepercent") {
                const percentage = Math.min(value, 100);
                charge.chargepercent = parseFloat(percentage.toFixed(2));

                if (isBlur || percentage === 100) {
                    const calculatedAmount = (percentage * netTotal) / 100;
                    charge.amount = parseFloat(calculatedAmount.toFixed(2));
                } else {
                    charge.amount = 0;
                }
            }
            else if (field === "amount") {
                charge.amount = parseFloat(value.toFixed(2));
                charge.chargepercent = 0;
            }
            else if (field === "gstPercent") {
                charge.gstPercent = parseFloat(value.toFixed(2));
            }
            else {
                charge[field] = value;
            }

            newCharges[index] = charge;
            return newCharges;
        });
    };

    // Add new charge row
    const addNewChargeRow = () => {
        setAdditionalCharges((prev) => [...prev, createEmptyCharge()]);
    };

    // Remove charge row
    const removeChargeRow = (index) => {
        if (additionalCharges.length > 1) {
            setAdditionalCharges((prev) => prev.filter((_, i) => i !== index));
        }
    };

    // Remove product row
    const removeRow = (index) => {
        const updatedRows = [...rows];
        updatedRows.splice(index, 1);
        setRows(updatedRows);
    };

    // Handle row changes with 2 decimal places
    const handleRowChange = (index, key, value) => {
        const updatedRows = [...rows];
        updatedRows[index][key] = value;

        if (["quantity", "unitRateInr", "gstPercent"].includes(key)) {
            const quantity = parseFloat(updatedRows[index].quantity) || 0;
            const unitRateInr = parseFloat(updatedRows[index].unitRateInr) || 0;
            const gstPercent = parseFloat(updatedRows[index].gstPercent) || 0;

            const amount = parseFloat((quantity * unitRateInr).toFixed(2));
            const gstAmount = parseFloat(((amount * gstPercent) / 100).toFixed(2));
            const totalinr = parseFloat((amount + gstAmount).toFixed(2));

            updatedRows[index].amount = amount;
            updatedRows[index].totalinr = totalinr;
        }

        setRows(updatedRows);
    };

    // Calculate products total with 2 decimal places
    const productsTotal = useMemo(() => {
        const total = rows.reduce((total, row) => {
            const rowTotal = (row.quantity || 0) * (row.unitRateInr || 0) * (1 + (row.gstPercent || 0) / 100);
            return total + rowTotal;
        }, 0);
        return parseFloat(total.toFixed(2));
    }, [rows]);

    useEffect(() => {
        // Recalculate charge amounts based on percentages when productsTotal changes
        setAdditionalCharges(prevCharges => {
            return prevCharges.map(charge => {
                if (charge.chargepercent > 0) {
                    return {
                        ...charge,
                        amount: parseFloat(((charge.chargepercent * productsTotal) / 100).toFixed(2))
                    };
                }
                return charge;
            });
        });
    }, [productsTotal]);

    // Calculate charges total with 2 decimal places
    const additionalChargesTotal = useMemo(() => {
        const total = additionalCharges.reduce((total, charge) => {
            const chargeTotal = (charge.amount || 0) * (1 + (charge.gstPercent || 0) / 100);
            return total + chargeTotal;
        }, 0);
        return parseFloat(total.toFixed(2));
    }, [additionalCharges]);

    // Calculate gross total and round to nearest integer with 2 decimal places
    const grossTotal = parseFloat((productsTotal + additionalChargesTotal).toFixed(2));
    const roundedGrossTotal = Math.round(grossTotal);
    const grandTotal = roundedGrossTotal;

    // Form validation
    const validateForm = () => {
        if (!isEnquiryValid) {
            Swal.fire("Error", "Please enter a valid delivery challan number", "error");
            return false;
        }
        if (!commonFieldsData.customer) {
            Swal.fire("Error", "Please select a customer", "error");
            return false;
        }
        if (!commonFieldsData.customerMultipleAddress) {
            Swal.fire("Error", "Please select customer address", "error");
            return false;
        }
        if (rows.length === 0) {
            Swal.fire("Error", "Please add at least one product", "error");
            return false;
        }
        return true;
    };

    // Handle form submission
    const handleSubmit = async () => {
        if (!validateForm()) return;

        setIsLoading(true);

        // Prepare delivery challan items with 2 decimal places
        const deliveryChallanItems = rows.map((row) => ({
            product: { id: row.value },
            quantity: row.quantity,
            uom: row.uom,
            unitrateinr: parseFloat(row.unitRateInr.toFixed(2)),
            gst: parseFloat(row.gstPercent.toFixed(2)),
            amount: parseFloat(row.amount.toFixed(2)),
            totalinr: parseFloat(row.totalinr.toFixed(2)),
            productremarks: row.productremarks,
            partno: row.partno || "",
            hsnsacno: row.hsnsacno || "",
            serialnumber: row.serialnumber || "",
            moc: row.moc || "",
            type: row.type || "",
            size: row.size || "",
            rating: row.rating || "",
            classes: row.classes || "",
            schedule: row.schedule || "",
            certification: row.certification || "",
        }));

        // Prepare additional charges with 2 decimal places
        const additionalChargesData = additionalCharges
            .filter((charge) => charge.description && (charge.amount > 0 || charge.chargepercent > 0))
            .map((charge) => {
                const chargeAmount = parseFloat(charge.amount.toFixed(2));
                const gstPercent = parseFloat(charge.gstPercent.toFixed(2));
                const gstAmount = parseFloat((chargeAmount * gstPercent / 100).toFixed(2));
                const chargetotal = parseFloat((chargeAmount + gstAmount).toFixed(2));

                return {
                    chargetype: charge.description,
                    chargepercent: parseFloat(charge.chargepercent.toFixed(2)),
                    chargeamount: chargeAmount,
                    chargegst: gstPercent,
                    chargetotal: chargetotal,
                    isPercentBased: charge.isPercentBased,
                };
            });

        // Calculate totals with 2 decimal places
        const additionalChargesTotalCalc = parseFloat(additionalChargesData.reduce(
            (sum, charge) => sum + charge.chargetotal,
            0
        ).toFixed(2));

        const productsTotalCalc = parseFloat(deliveryChallanItems.reduce(
            (sum, item) => sum + item.totalinr,
            0
        ).toFixed(2));

        const grossTotalCalc = parseFloat((productsTotalCalc + additionalChargesTotalCalc).toFixed(2));

        // Prepare payload
        const payload = {
            customer: commonFieldsData.customer ? { id: commonFieldsData.customer.value } : null,
            contactperson: commonFieldsData.customerDetails?.contactperson,
            contactno: commonFieldsData.customerDetails?.contactno,
            email: commonFieldsData.customerDetails?.email,
            customeraddress: commonFieldsData.customerMultipleAddress
                ? { id: commonFieldsData.customerMultipleAddress.value }
                : null,
            freight: commonFieldsData.customerDetails.freight,
            packingandforwarding: commonFieldsData.customerDetails.packingandforwarding,
            paymentterm: commonFieldsData.customerDetails.paymentterm,
            shipto: commonFieldsData.shipTo ? { id: commonFieldsData.shipTo.value } : null,
            billto: commonFieldsData.billTo ? { id: commonFieldsData.billTo.value } : null,
            branch: commonFieldsData.branch ? { id: commonFieldsData.branch.value } : null,
            warehouse: commonFieldsData.warehouse ? { id: commonFieldsData.warehouse.value } : null,
            deliveryChallanItems: deliveryChallanItems,
            additionalCharges: additionalChargesData.length > 0 ? additionalChargesData : null,
            nettotalproduct: productsTotalCalc,
            additionalchargestotal: additionalChargesTotalCalc,
            grosstotal: grossTotalCalc,
            grandtotalproduct: grossTotalCalc,
            deliverychallantype: "Manufacturing",
            deliverychallancategory: "Domestic",
            deliverynoteno,
            deliverynotedate,
            sodate,
            sono,
            customermaterialcode,
            deliveryterm,
            dispatchdocno,
            kindattn,
            termsofdelivery,
            buyerorderno,
            buyerorderdate,
            destination,
            dispatchthrough,
            otherreference,
        };

        try {
            const response = await axios.post(`${BASE_URL}deliveryChallan/save`, payload, {
                headers: authHeader(),
            });
            Swal.fire("Success", "Delivery challan created successfully", "success");
            navigate("/dcindex/1");
        } catch (error) {
            console.error("Submission error:", error);
            Swal.fire(
                "Error",
                error.response?.data?.message ||
                error.response?.data ||
                "Failed to create delivery challan",
                "error"
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="container">
            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>

                {/* Delivery Note Details */}
                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Delivery Note Number: *</Form.Label>
                            <Form.Control
                                type="text"
                                value={deliverynoteno}
                                onChange={e => {
                                    setdeliverynoteno(e.target.value);
                                    setFormSubmitted(false);
                                }}
                                isInvalid={
                                    (formSubmitted && !isEnquiryValid) ||
                                    enquiryValidationMsg.includes('exists') ||
                                    enquiryValidationMsg.includes('Error') ||
                                    enquiryValidationMsg.includes('allowed')
                                }
                                required
                            />
                            {enquiryValidationMsg && (
                                <Form.Control.Feedback type={
                                    enquiryValidationMsg.includes('exists') ||
                                        enquiryValidationMsg.includes('Error') ||
                                        enquiryValidationMsg.includes('allowed') ?
                                        "invalid" : "valid"
                                }>
                                    {enquiryValidationMsg}
                                </Form.Control.Feedback>
                            )}
                            {formSubmitted && !isEnquiryValid && !enquiryValidationMsg && (
                                <Form.Control.Feedback type="invalid">
                                    Please enter a valid delivery challan number
                                </Form.Control.Feedback>
                            )}
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group>
                            <Form.Label>Delivery Note Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={deliverynotedate}
                                onChange={e => setdeliverynotedate(e.target.value)}
                            />
                        </Form.Group>
                    </Col>

                    {/* Sales Order Details */}
                    <Col md={6}>
                        <Form.Group controlId="sono">
                            <Form.Label>Sales Order No.</Form.Label>
                            <Form.Control
                                type="text"
                                value={sono}
                                onChange={(e) => setsono(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="sodate">
                            <Form.Label>Sales Order Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={sodate}
                                onChange={(e) => setsodate(e.target.value)}
                            />
                        </Form.Group>
                    </Col>

                    {/* Buyer Order Details */}
                    <Col md={6}>
                        <Form.Group controlId="buyerorderno">
                            <Form.Label>Buyer Order No.</Form.Label>
                            <Form.Control
                                type="text"
                                value={buyerorderno}
                                onChange={(e) => setbuyerorderno(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="buyerorderdate">
                            <Form.Label>Buyer Order Date</Form.Label>
                            <Form.Control
                                type="date"
                                value={buyerorderdate}
                                onChange={(e) => setAmendmentdate(e.target.value)}
                            />
                        </Form.Group>
                    </Col>

                    {/* Dispatch Info */}
                    <Col md={6}>
                        <Form.Group controlId="dispatchthrough">
                            <Form.Label>Dispatch Through</Form.Label>
                            <Form.Control
                                type="text"
                                value={dispatchthrough}
                                onChange={(e) => setdispatchthrough(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="destination">
                            <Form.Label>Destination</Form.Label>
                            <Form.Control
                                type="text"
                                value={destination}
                                onChange={(e) => setdestination(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                {/* Common DC Fields */}
                <CommonDcFields
                    onDataChange={handleCommonFormData}
                />

                {/* Additional Info */}
                <Row className="mb-3">
                    <Col md={6}>
                        <Form.Group controlId="dispatchdocno">
                            <Form.Label>Dispatch Doc No.</Form.Label>
                            <Form.Control
                                type="text"
                                value={dispatchdocno}
                                onChange={(e) => setdispatchdocno(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group controlId="kindattn">
                            <Form.Label>Kind Attention</Form.Label>
                            <Form.Control
                                type="text"
                                value={kindattn}
                                onChange={(e) => setkindattn(e.target.value)}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={6}>
                        <Form.Group controlId="termsofdelivery">
                            <Form.Label>Delivery Term</Form.Label>
                            <Form.Control
                                type="text"
                                value={termsofdelivery}
                                onChange={(e) => settermsofdelivery(e.target.value)}
                            />
                        </Form.Group>
                    </Col>

                    <Col md={12}>
                        <Form.Group controlId="otherreference">
                            <Form.Label>Other Reference</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                value={otherreference}
                                onChange={(e) => setotherreference(e.target.value)}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                {/* Products Section */}
                <div className="mt-4">
                    <h5>Products</h5>
                    <Row>
                        <Col md="12">
                            <Form.Group>
                                <Form.Label>Select Product</Form.Label>
                                <Select
                                    value={selectedProduct}
                                    onChange={handleProductChange}
                                    options={productOptions}
                                    placeholder="Search and select product"
                                    onInputChange={handleProductSearchChange}
                                    isClearable
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                    }}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    {/* Common ProductTable Component */}
                    <ProductTableSales
                        rows={rows}
                        unitOptions={UNIT_OPTIONS}
                        onRowChange={handleRowChange}
                        onRemoveRow={removeRow}
                    />
                </div>

                {/* Charges Section */}
                <ChargesSection
                    additionalCharges={additionalCharges}
                    chargeOptions={CHARGE_OPTIONS}
                    productsTotal={productsTotal}
                    additionalChargesTotal={additionalChargesTotal}
                    grossTotal={grossTotal}
                    grandTotal={grandTotal}
                    onChargeChange={handleChargeChange}
                    onAddCharge={addNewChargeRow}
                    onRemoveCharge={removeChargeRow}
                />

                {/* Submit Buttons */}
                <div className="d-flex justify-content-end mt-4">
                    <button
                        type="submit"
                        className="btn btn-primary me-2"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <>
                                <Spinner as="span" animation="border" size="sm" />
                                <span className="ms-2">Submitting...</span>
                            </>
                        ) : (
                            "Submit"
                        )}
                    </button>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => navigate(-1)}
                    >
                        Cancel
                    </button>
                </div>
            </Form>
        </div>
    );
}

export default MDCCreate;